// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".features-rows[data-v-1ba9b628]{margin-bottom:7rem}@media(min-width:768px){.features-rows h2[data-v-1ba9b628]{font-size:52px!important}}.features-rows .features__box--wrapper[data-v-1ba9b628]{padding-top:4rem;padding-bottom:3rem;border-top:2px solid var(--lightgrey-price-box)}.features-rows .features__box:last-of-type .features__box--wrapper[data-v-1ba9b628]{border-bottom:2px solid var(--lightgrey-price-box)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
